/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPServerEntry,
  ExternalMCPServerEntry$inboundSchema,
} from "./externalmcpserverentry.js";

export type ListCatalogResponseBody = {
  /**
   * Pagination cursor for the next page
   */
  nextCursor?: string | undefined;
  /**
   * List of available MCP servers
   */
  servers: Array<ExternalMCPServerEntry>;
};

/** @internal */
export const ListCatalogResponseBody$inboundSchema: z.ZodMiniType<
  ListCatalogResponseBody,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    servers: z.array(ExternalMCPServerEntry$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listCatalogResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListCatalogResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListCatalogResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCatalogResponseBody' from JSON`,
  );
}
